import { render, staticRenderFns } from "./DownloadsView.vue?vue&type=template&id=94ac2ed4&scoped=true&"
import script from "./DownloadsView.vue?vue&type=script&lang=js&"
export * from "./DownloadsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ac2ed4",
  null
  
)

export default component.exports